var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-toast-container"},_vm._l((_vm.toasts),function(toast){return _c('TwToast',_vm._b({key:toast.id,on:{"dismiss":_vm.removeToast}},'TwToast',toast,false))}),1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }